// allows to get a form value for nested array fields
import { get } from "lodash";

// matches enteredTransports[1].manualDepartureTime
const NESTED_OBJECT_FIELD_REGEX = /(\w+)\[(\d+)]\.(\w+)/;

// matches enteredTransports[1]
const NESTED_OBJECT_REGEX = /(\w+)\[(\d+)]/;

const getFlatFormValue = (formValues: any, fieldKey: string): any => {
  if (NESTED_OBJECT_FIELD_REGEX.test(fieldKey)) {
    const matchResult = NESTED_OBJECT_FIELD_REGEX.exec(fieldKey);
    if (matchResult) {
      const arrayName = matchResult[1];
      const index = parseInt(matchResult[2]);
      const subKey = matchResult[3];

      return formValues[arrayName]?.[index]?.[subKey];
    }
  }

  if (NESTED_OBJECT_REGEX.test(fieldKey)) {
    const matchResult = NESTED_OBJECT_REGEX.exec(fieldKey);
    if (matchResult) {
      const arrayName = matchResult[1];
      const index = parseInt(matchResult[2]);

      return formValues[arrayName]?.[index];
    }
  }

  // Using "get" supports nested object keys, which are registered by checkbox children of multi checkboxes
  // e.g. "multiselect.checkbox1"
  return get(formValues, fieldKey);
};

export default getFlatFormValue;
